// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Uuid from "../../externals/Uuid.res.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as FieldsetLayoutPanel from "../../resources/layout-and-structure/FieldsetLayoutPanel.res.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as CatalogCategoryPicker from "./CatalogCategoryPicker.res.js";
import * as CatalogProductEditForm from "./CatalogProductEditForm.res.js";

let OrganisationProduct_ShopIdNotFound = /* @__PURE__ */Primitive_exceptions.create("CatalogProductEditFormOrganisationFieldsetPanel.OrganisationProduct_ShopIdNotFound");

function CatalogProductEditFormOrganisationFieldsetPanel(props) {
  let dispatch = CatalogProductEditForm.useFormDispatch();
  let match = React.useState(() => "");
  let setFormattedValue = match[1];
  let activeShop = Auth.useActiveShop();
  let shopId;
  if (activeShop !== undefined) {
    shopId = activeShop.id;
  } else {
    throw {
      RE_EXN_ID: OrganisationProduct_ShopIdNotFound,
      Error: new Error()
    };
  }
  let onChange = category => {
    if (typeof category !== "object") {
      dispatch({
        TAG: "FieldValueChanged",
        _0: "CategoryId",
        _1: param => {}
      });
      return setFormattedValue(param => I18n.t("Not classified"));
    }
    let match = category._0;
    let formattedName = match.formattedName;
    let id = match.id;
    let uuid = id === "" ? undefined : Uuid.fromString(id);
    dispatch({
      TAG: "FieldValueChanged",
      _0: "CategoryId",
      _1: param => uuid
    });
    setFormattedValue(param => formattedName);
  };
  return JsxRuntime.jsx(FieldsetLayoutPanel.make, {
    title: I18n.t("Organisation"),
    description: I18n.t("Enter in which categorie this product should belong to."),
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(CatalogCategoryPicker.make, {
        triggerType: "input",
        placeholder: I18n.t("Add a category"),
        value: match[0],
        shopId: shopId,
        onChange: onChange
      }),
      spaceLeft: "normal"
    })
  });
}

let make = React.memo(CatalogProductEditFormOrganisationFieldsetPanel);

export {
  OrganisationProduct_ShopIdNotFound,
  make,
}
/* make Not a pure module */
